import { render, staticRenderFns } from "./downSalaryAwardFinishList.vue?vue&type=template&id=47cddbac&"
import script from "./downSalaryAwardFinishList.vue?vue&type=script&lang=js&"
export * from "./downSalaryAwardFinishList.vue?vue&type=script&lang=js&"
import style0 from "./downSalaryAwardFinishList.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports